<template>
  <div class="hw-page">
    <navigation />
    <home />
    <services />
    <process-steps />
    <about />
    <mkgest />
    <clients />
    <contact />
    <foote />
    <button v-show="fab" class="hw-top" type="button" aria-label="Voltar ao topo" @click="toTop">
      <v-icon>mdi-arrow-up</v-icon>
    </button>
  </div>
</template>

<script>
import navigation from "../components/Navigation";
import foote from "../components/Footer";
import home from "../components/Home";
import services from "../components/Services";
import processSteps from "../components/Process";
import about from "../components/About";
import mkgest from "../components/MKGest";
import clients from "../components/Clients";
import contact from "../components/Contact";

export default {
  name: "HomePage",
  components: {
    navigation,
    foote,
    home,
    services,
    processSteps,
    about,
    mkgest,
    clients,
    contact,
  },
  data: () => ({
    fab: false,
  }),
  methods: {
    onScroll() {
      this.fab = window.pageYOffset > 60;
    },
    toTop() {
      this.$vuetify.goTo(0);
    },
  },
  mounted() {
    window.addEventListener("scroll", this.onScroll, { passive: true });
    this.onScroll();
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
};
</script>
